(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/emp-video-player/assets/javascripts/video-player-loader.js') >= 0) return;  svs.modules.push('/components/components/emp-video-player/assets/javascripts/video-player-loader.js'); 'use strict';

const {
  loadVideoComponent,
  startVideoPlayer,
  setupVideo,
  setupVideoFromAttributes
} = svs.components.emp_video_player.helpers.client;
let videoOptionsArray = [];

const checkParams = videos => {
  const errorNotArray = 'Param should be an array of video objects';
  const missingElementNode = 'Missing node property for video';
  const missingOptionsObject = 'Missing options object for video';

  if (!Array.isArray(videos)) {
    return errorNotArray;
  }

  for (let index = 0; index < videos.length; index++) {
    const video = videos[index];

    if (!video.node) {
      return missingElementNode;
    }

    if (!video.options) {
      return missingOptionsObject;
    }
  }
};


const prepareVideo = videos => {
  const jPromise = $.Deferred();
  const runParallell = [];
  const notValidParams = checkParams(videos);

  if (notValidParams) {
    return jPromise.reject(notValidParams);
  }

  videoOptionsArray = [];

  for (let index = 0; index < videos.length; index++) {
    const video = videos[index];

    if (video.options.noThumbnail) {
      videoOptionsArray.push(video);
    }

    runParallell.push(setupVideo(video.node, video.options));
  }

  return $.when.apply(null, runParallell);
};


const loadVideoPlayer = () => {
  const responsePromise = $.Deferred();

  if (videoOptionsArray.length > 0) {
    try {
      loadVideoComponent(() => {
        const parallellJobs = [];

        for (let index = 0; index < videoOptionsArray.length; index++) {
          const video = videoOptionsArray[index]; 

          const parallellJob = $.Deferred();
          startVideoPlayer(video.node, video.options, (error, response) => {
            if (error) {
              parallellJob.reject(response);
            }

            parallellJob.resolve(response);
          });
          parallellJobs.push(parallellJob);
        } 


        $.when.apply(null, parallellJobs).then(() => {
          responsePromise.resolve();
        }).catch(() => {
          responsePromise.reject();
        });
      });
    } catch (error) {
      responsePromise.reject(error);
    }

    return responsePromise;
  }

  return responsePromise.resolve('Nothing to load');
};


const preRenderSetup = videoElement => {
  if (videoElement) {
    const singleVideoElement = videoElement.querySelector('.js-emp-placeholder');
    setupVideoFromAttributes(singleVideoElement);
  } else {
    const videoElements = document.getElementsByClassName('js-emp-placeholder');

    for (let i = 0; i < videoElements.length; i++) {
      const element = videoElements[i];
      setupVideoFromAttributes(element);
    }
  }
};

svs.components.emp_video_player.contentLoader = {
  loadVideoPlayer,
  preRenderSetup,
  prepareVideo
};
 })(window);